import React from 'react'
import { useForm } from 'react-hook-form'
import PropTypes from 'prop-types'

import {
  formContainer,
  titleContainer,
  mainTitle,
  buttonContainer
} from './styles/LoginForm.style'

import { Button } from '../shared/styles/Button.style'
import Input from '../shared/Input'

import * as validators from '../../utils/validators'

const ChangeEmailForm = ({ onSubmit, emailValue, translation, lang }) => {
  const required = lang === 'pt-BR' ? validators.requiredPT : validators.requiredES
  const email = lang === 'pt-BR' ? validators.emailPT : validators.emailES
  const { control, handleSubmit } = useForm({
    defaultValues: {
      email: emailValue || ''
    }
  })

  return (
    <form className={formContainer} onSubmit={handleSubmit(onSubmit)}>
      <header className={titleContainer}>
        <h1 className={mainTitle}>{translation('changeEmailForm')['emailFormTitle']}</h1>
      </header>

      <div>
        <Input
          control={control}
          name='email'
          rules={{ validate: validators.composeValidators(required, email) }}
          placeholder={translation('changeEmailForm')['emailPlaceholder']}
          type='text'
          block
        />
      </div>

      <div className={buttonContainer}>
        <Button
          type='submit'
        >
          {translation('changeEmailForm')['changeButton']}
        </Button>
      </div>
    </form>
  )
}

ChangeEmailForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  emailValue: PropTypes.string,
  translation: PropTypes.func,
  lang: PropTypes.string
}

export default ChangeEmailForm
